import React from 'react'
import { Column } from '@resurs/midas-react'
import { colors } from '@resurs/midas'
import { getText } from '../../../../internal/TextLabels'

const PendingApplicationCoCustomerNotAvailable = () => (
  <div
    style={{
      border: '1px solid rgba(0,0,0,0.12)',
      borderTop: `3px solid ${colors.red}`,
      background: 'white',
      margin: '1rem',
    }}
  >
    <Column col12 noPadding>
      <div style={{ padding: '2rem' }}>
        <strong>
          {getText('payApply.paymentMethod.coApplicantInfoHeader')}
        </strong>
        <div style={{ padding: '2rem 0' }}>
          {getText('payApply.paymentMethod.coApplicationInfoNotAvailable')}
        </div>
      </div>
    </Column>
  </div>
)

export default PendingApplicationCoCustomerNotAvailable
